import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';

import {
    useCheckerContext,
    checkTypes
} from 'client/components/infoDialog/ProviderFlowInfoAndActionChecker';

function MaskFlowInfoAndAction() {
    // 收集所有 dialog 依賴的 redux state
    // DialogInfoBeforeLoginTrigger
    const gameRunningStatus = useSelector(s => s.promoState.gameRunningStatus);
    const isLogin = useSelector(s => s.userLoginState.isLogin);
    const loginMethod = useSelector(s => s.settingPromo.loginMethod);
    const promoType = useSelector(s => s.promo.type);
    // DialogInfoAfterLoginTrigger
    const isInPlayTimePeriod = useSelector(
        s => s.promoState.periodPlayMatchedInfo?.matchedInfo?.match
    );
    // DialogQualifyCheckTrigger
    const isTestMode = useSelector(s => s.promoState.isTestMode);
    const hasUsablePasscode = useSelector(s => s.promoState.hasUsablePasscode);
    const notQualifiedType = useSelector(s => s.userLoginState.notQualifiedType);
    const gameResultRecords = useSelector(s => s.userGameResultRecords || []);
    const userEntryState = useSelector(s => s.userEntryState);
    const qualifyWithdrawUuid = useSelector(s => s.settingPointSystems.qualifyWithdrawUuid || '');
    const currentEntryUUID = useSelector(s => s.userEntryState.currentEntryUUID);

    const checkerApi = useCheckerContext();
    const [coverMask, setCoverMask] = useState(false);

    // 用 useMemo 儲存 stringify 結果
    const dialogDepsString = useMemo(
        () =>
            JSON.stringify({
                gameRunningStatus,
                isLogin,
                loginMethod,
                promoType,
                isInPlayTimePeriod,
                isTestMode,
                hasUsablePasscode,
                notQualifiedType,
                gameResultRecordsLength: gameResultRecords.length,
                userEntryState,
                qualifyWithdrawUuid,
                currentEntryUUID
            }),
        [
            gameRunningStatus,
            isLogin,
            loginMethod,
            promoType,
            isInPlayTimePeriod,
            isTestMode,
            hasUsablePasscode,
            notQualifiedType,
            gameResultRecords.length,
            userEntryState,
            qualifyWithdrawUuid,
            currentEntryUUID
        ]
    );

    useEffect(() => {
        if (
            checkerApi.check(
                [checkTypes.LOGIN_STATUS, checkTypes.PROMO_STATUS, checkTypes.QUALIFY_STATUS],
                false
            )
        ) {
            setCoverMask(false);
        } else {
            setCoverMask(true);
        }
    }, [checkerApi, dialogDepsString]); // 依賴所有 dialog 相關 state

    return (
        <div
            css={[maskStyle, coverMask && coverMaskStyle]}
            onClick={() =>
                checkerApi.check([
                    checkTypes.LOGIN_STATUS,
                    checkTypes.PROMO_STATUS,
                    checkTypes.QUALIFY_STATUS
                ])
            }
        />
    );
}

export default MaskFlowInfoAndAction;

const maskStyle = css`
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 5;
    cursor: pointer;
    pointer-events: none;
`;

const coverMaskStyle = css`
    pointer-events: auto;
`;
